/**
 * ノードの「…」メニューを組み立てる部品。
 *
 * 通常の編集画面と公開閲覧画面の両方から使う。閉じ方だけが画面ごとに
 * 違うため、メニューを閉じる処理は呼び出し側から渡してもらう。
 */

/** アイコンだけのボタン。ラベルは title と aria-label に入れる */
export function makeIconButton(label: string, title: string, handler: (event: Event) => void): HTMLButtonElement {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'icon-button';
  button.textContent = label;
  button.title = title;
  button.setAttribute('aria-label', title);
  button.addEventListener('click', handler);
  return button;
}

export interface NodeMenuButtonOptions {
  /** クリックしてもメニューを閉じない場合だけ false を渡す */
  closeOnClick?: boolean;
}

/**
 * メニューの項目1つを作る。
 *
 * @param closeMenus クリック時にメニューを閉じる処理。画面ごとに違う
 */
export function makeNodeMenuButton(
  label: string,
  title: string,
  handler: () => unknown,
  closeMenus: () => void,
  options: NodeMenuButtonOptions = {}
): HTMLButtonElement {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'node-menu-item';
  button.textContent = label;
  button.title = title;
  button.setAttribute('aria-label', title);
  button.setAttribute('role', 'menuitem');
  button.addEventListener('click', async (event) => {
    event.stopPropagation();
    if (options.closeOnClick !== false) {
      closeMenus();
    }
    await handler();
  });
  return button;
}
